class ColorSwatches {
  constructor() {
    this.init();
  }

  init() {
    document.querySelectorAll('.color-swatches').forEach(swatchContainer => {
      const productBlock = swatchContainer.closest('.product-block');
      if (!productBlock) return;
      
      const primaryImage = productBlock.querySelector('.product-block__image--primary');
      if (!primaryImage) return;
      
      // Store original image data
      const originalImageElement = primaryImage.querySelector('.rimage-background, img');
      if (!originalImageElement) return;
      
      const originalSrc = originalImageElement.dataset.lazyBgsetSrc || originalImageElement.src;
      
      swatchContainer.querySelectorAll('.color-swatch').forEach(swatch => {
        // Hover to preview
        swatch.addEventListener('mouseenter', () => {
          const newImageUrl = swatch.dataset.variantImage;
          
          // Update image
          if (originalImageElement.dataset.lazyBgsetSrc) {
            // For lazy-loaded background images
            originalImageElement.style.backgroundImage = `url('${newImageUrl}')`;
          } else if (originalImageElement.tagName === 'IMG') {
            // For regular img tags
            originalImageElement.src = newImageUrl;
            if (originalImageElement.srcset) {
              originalImageElement.srcset = newImageUrl;
            }
          }
        });
        
        // Click to navigate
        swatch.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = swatch.dataset.variantUrl;
        });
      });
      
      // Reset on mouse leave
      swatchContainer.addEventListener('mouseleave', () => {
        if (originalImageElement.dataset.lazyBgsetSrc) {
          originalImageElement.style.backgroundImage = `url('${originalSrc}')`;
        } else if (originalImageElement.tagName === 'IMG') {
          originalImageElement.src = originalSrc;
        }
      });
    });
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ColorSwatches());
} else {
  new ColorSwatches();
}

// Re-initialize after AJAX page loads (for pagination)
document.addEventListener('shopify:section:load', () => new ColorSwatches());
